/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../../../common";
import type {
  OrangeKitSafeFactoryV2,
  OrangeKitSafeFactoryV2Interface,
} from "../../../contracts/test/OrangeKitSafeFactoryV2";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
    ],
    name: "AddressEmptyCode",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "AddressInsufficientBalance",
    type: "error",
  },
  {
    inputs: [],
    name: "AlreadyInitialized",
    type: "error",
  },
  {
    inputs: [],
    name: "FailedInnerCall",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "InvalidEmergencyGovernanceAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidNewOwnerAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidNewSafeOwnerSingletonAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidNewSingletonAddress",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "singleton",
        type: "address",
      },
    ],
    name: "InvalidSingletonAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidTruncatedBitcoinAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidUpgradeInitData",
    type: "error",
  },
  {
    inputs: [],
    name: "NotAuthorized",
    type: "error",
  },
  {
    inputs: [],
    name: "SafeOwnerSingletonAlreadyUpgraded",
    type: "error",
  },
  {
    inputs: [],
    name: "SingletonAlreadyUpgraded",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "salt",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "safe",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "bitcoinSafeOwner",
        type: "address",
      },
    ],
    name: "NewEventV2",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "safe",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "bitcoinSafeOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bytes20",
        name: "truncatedBitcoinAddress",
        type: "bytes20",
      },
    ],
    name: "SafeDeployed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "oldSingleton",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newSingleton",
        type: "address",
      },
    ],
    name: "SafeOwnerSingletonUpgraded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "oldSingleton",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newSingleton",
        type: "address",
      },
    ],
    name: "SingletonUpgraded",
    type: "event",
  },
  {
    inputs: [],
    name: "bitcoinSafeOwnerProxyCreationCode",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes20",
        name: "truncatedBitcoinAddress",
        type: "bytes20",
      },
    ],
    name: "deploySafe",
    outputs: [
      {
        internalType: "contract SafeProxy",
        name: "safe",
        type: "address",
      },
      {
        internalType: "contract Proxy",
        name: "bitcoinSafeOwner",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "emergencyGovernance",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_newVariable",
        type: "string",
      },
    ],
    name: "initializeV2",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "initialized",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "initializedV2",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "newVariable",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes20",
        name: "truncatedBitcoinAddress",
        type: "bytes20",
      },
    ],
    name: "predictAddresses",
    outputs: [
      {
        internalType: "address",
        name: "safe",
        type: "address",
      },
      {
        internalType: "address",
        name: "bitcoinSafeOwner",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "safeOwnerSingleton",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "safeProxyCreationCode",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "safeSingleton",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newSafeOwnerSingleton",
        type: "address",
      },
    ],
    name: "upgradeSafeOwnerSingleton",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newSingleton",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "initData",
        type: "bytes",
      },
    ],
    name: "upgradeSingleton",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type OrangeKitSafeFactoryV2ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: OrangeKitSafeFactoryV2ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class OrangeKitSafeFactoryV2__factory extends ContractFactory {
  constructor(...args: OrangeKitSafeFactoryV2ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(overrides || {});
  }
  override deploy(overrides?: NonPayableOverrides & { from?: string }) {
    return super.deploy(overrides || {}) as Promise<
      OrangeKitSafeFactoryV2 & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(
    runner: ContractRunner | null
  ): OrangeKitSafeFactoryV2__factory {
    return super.connect(runner) as OrangeKitSafeFactoryV2__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): OrangeKitSafeFactoryV2Interface {
    return new Interface(_abi) as OrangeKitSafeFactoryV2Interface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): OrangeKitSafeFactoryV2 {
    return new Contract(
      address,
      _abi,
      runner
    ) as unknown as OrangeKitSafeFactoryV2;
  }
}
